import cx from "classnames";

import { Flex, OverflowText } from "@theorgchartdev/storybook";
import SystemGeneratedFieldPill, {
  isSystemGeneratedInternalField,
  isSystemGeneratedMappedField
} from "@/appComponents/Blocks/Cards/ProfileBaseballCard/SystemGeneratedFieldPill";

type Props = {
  className?: string;
  name: string;
  isSelected?: boolean;
  label?: string;
  size?: "small" | "medium" | "large";
  fieldMapping?: { [key: string]: string };
  systemGeneratedFields?: Set<string>;
};

export const FieldLabelComposite = (props: Props) => {
  const baseTextClass = "ocn-folder-row-text";
  const activeTextClass = props.isSelected ? "ocn-file-row-active-text" : null;

  const showLabel = (() => {
    if (!props.label) return false;

    return props.name !== props.label;
  })();

  const name = props.name;
  return (
    <Flex
      className={cx("oc-fill-width", props.className)}
      flex={"1"}
      direction={"row"}
      gap={"8px"}
      alignItems="center"
      style={{ alignItems: "center", minHeight: "40px", height: "40px" }}
    >
      <div className="oc-overflow-hidden oc-shrink-0">
        <OverflowText className={cx(baseTextClass, activeTextClass, "oc-block")} size={props.size}>
          {name}
        </OverflowText>
      </div>
      {showLabel && (
        <div className="oc-overflow-hidden oc-shrink-1">
          <OverflowText
            children={`(${props.label ?? ""})`}
            className={cx(baseTextClass, activeTextClass, "oc-block")}
            modifier={"italic"}
            size={props.size}
          />
        </div>
      )}
      {(props.systemGeneratedFields
        ? props.systemGeneratedFields.has(props.name)
        : isSystemGeneratedMappedField(props.name, props.fieldMapping) ||
          isSystemGeneratedInternalField(props.name)) && (
        <Flex
          alignItems={"center"}
          height={"100%"}
          style={{
            flexShrink: "0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
          width={"100%"}
        >
          <SystemGeneratedFieldPill fieldName={props.name} forceRender={true} />
        </Flex>
      )}
    </Flex>
  );
};
